import styled from 'styled-components'

const ModalContent = styled.div`
  padding: 50px;
`

export default ModalContent
